import React, { useMemo } from 'react';

import { ActionVariant, ITableCellAction, TableCellActions } from '~/@components/Table/TableCellActions';
import { IDeliveryLine } from '~/@store/deliveryLines/deliveryLines.types';
import { showDeliveryLinesMassEditDialog } from '~/@views/AdminView/common/DeliveryLinesMassEditForm';

type Props = {
    deliveryLine: IDeliveryLine;
};

export const DeliveryLineOrderNumberCell = ({ deliveryLine }: Props) => {
    const disabled = !!deliveryLine.deletedAt;

    const actions: Array<ITableCellAction> = useMemo(
        () => [
            {
                variant: ActionVariant.EDIT,
                onClick: () => showDeliveryLinesMassEditDialog(deliveryLine.orderNumber),
                disabled,
            },
        ],
        [deliveryLine, disabled]
    );

    return <TableCellActions actions={actions}>{deliveryLine.orderNumber}</TableCellActions>;
};
